import { render, staticRenderFns } from "./string.vue?vue&type=template&id=acb87cce&scoped=true"
import script from "./string.vue?vue&type=script&lang=js"
export * from "./string.vue?vue&type=script&lang=js"
import style0 from "./string.vue?vue&type=style&index=0&id=acb87cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb87cce",
  null
  
)

export default component.exports